// extracted by mini-css-extract-plugin
export default {"parent":"style_parent__l3vX3","frame":"style_frame__9a0MT","content":"style_content__j-tHp","crop":"style_crop__KWb-2"};